import { currency } from "@src/utils/formatters";
import React, { type FC } from "react";
import type { ColumnProps } from ".";

export const Amount: FC<React.PropsWithChildren<ColumnProps>> = ({ row }) => {
  return (
    <React.Fragment>
      {currency.formatByCurrency(
        row.stats.total_amount_in_currency,
        row.currency,
      )}
    </React.Fragment>
  );
};
